import React, { PureComponent } from 'react'
import Lottie from '../../hoc/Lottie'
import styled from 'styled-components'
import { IAssetData, IConfig, FreezePosition } from '../../helpers/data/assetData'
import { ISize } from '../../helpers/data/size'

const defaultConfig = {}

const AssetElement = styled.div`
	width: 100%;
	height: 100%;
`

interface IAnimationAssetProps {
	assetData: IAssetData
	path: string
	size: ISize
	onAssetLoaded: () => void
	onComplete?: () => void
	renderer?: string
	areAnimationsEnabled?: boolean
	freezePosition?: FreezePosition
}

class AnimationAsset extends PureComponent<IAnimationAssetProps> {
	private element: Lottie | null = null

	setElement = (elem: Lottie) => {
		this.element = elem
	}

	componentWillReceiveProps(props: IAnimationAssetProps) {
		if (this.element && props.size !== this.props.size) {
			this.element.resize()
		}
	}

	getFreezeFrame(config: IConfig): number | undefined {
		const segments = config.segmentsData?.segments
		if (!segments || !Array.isArray(segments[0])) {
			return undefined
		}

		const segmentPairs = segments as unknown as number[][]
		const freezePosition = this.props.freezePosition ?? FreezePosition.FirstSegmentStart
		const firstSegment = segmentPairs[0]
		const lastSegment = segmentPairs[segmentPairs.length - 1]

		switch (freezePosition) {
			case FreezePosition.FirstSegmentStart:
				return firstSegment[0]
			case FreezePosition.FirstSegmentEnd:
				return firstSegment[1]
			case FreezePosition.LastSegmentStart:
				return lastSegment[0]
			case FreezePosition.LastSegmentEnd:
				return lastSegment[1]
			default:
				return firstSegment[0]
		}
	}

	render() {
		const assetData = this.props.assetData
		const config: IConfig = assetData.config || defaultConfig
		const frozen = this.props.areAnimationsEnabled === false
		const freezeFrame = frozen ? this.getFreezeFrame(config) : undefined

		return (
			<Lottie
				ref={this.setElement}
				onLoad={this.props.onAssetLoaded}
				basePath={this.props.path}
				path={this.props.path + assetData.path}
				loop={config.loop}
				autoplay={config.autoplay}
				segmentsData={config.segmentsData}
				assetsPath={config.assetsPath}
				listeners={{
					onComplete: this.props.onComplete,
				}}
				renderer={this.props.renderer}
				frozen={frozen}
				freezeFrame={freezeFrame}
			>
				<AssetElement />
			</Lottie>
		)
	}
}

export default AnimationAsset
